import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { reducer as formReducer } from "redux-form";
import Settings from "./Settings";
import Auth from "./Auth";
import BusinessPage from "./BusinessPage";
import ChangeTitle from "./ChangeTitle";
import BookAppointment from "./BookAppointment";
import CustomerBooking from "./CustomerBooking";
import ModalReducer from "./Modal";
import EmployeeReducer from "./EmployeeReducer";
import LoginReducer from "./LoginReducer";
import AdminBookAppointment from "./AdminBookAppointment";
import CustomerAdminReducer from "./CustomerAdminReducer";
import ServicesAdminReducer from "./ServicesAdminReducer";
import AdminSettings from "./AdminSettings";
import CategoryAdminReducer from "./CategoryAdminReducer";
import ReportsReducer from "./Reports.Reducer";
import BusinessSuperAdmin from "./BusinessSuperAdminReducer";
import UsersReducer from './UsersReducer';
import CustomerAppointment from "./CustomerAppointment";
import CustomerProfile from "./CustomerProfile";
const allReducers = combineReducers({
  routing: routerReducer,
  settings: Settings,
  auth: Auth,
  business: BusinessPage,
  changeTitle: ChangeTitle,
  bookAppointment: BookAppointment,
  customerBooking: CustomerBooking,
  form: formReducer,
  modal: ModalReducer,
  employee: EmployeeReducer,
  login: LoginReducer,
  adminBookAppointment: AdminBookAppointment,
  customerAdmin: CustomerAdminReducer,
  servicesAdmin: ServicesAdminReducer,
  adminSettings: AdminSettings,
  categoryAdmin: CategoryAdminReducer,
  reports: ReportsReducer,
  businessSuperAdmin: BusinessSuperAdmin,
  user: UsersReducer,
  customerAppointment: CustomerAppointment,
  customerProfile:CustomerProfile,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }

  return allReducers(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./reducers/index.js